
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { mdiAlert, mdiCheckCircle } from '@mdi/js';

	const Props = Vue.extend({
		props: {
			/**
			 * Title of the card
			 * If not provided, the card will
			 * not be displayed
			 */
			title: {
				type: String,
				default: undefined
			},
			/** The main message */
			message: {
				type: String,
				default: undefined
			},
			/** State, error or success */
			state: {
				type: String,
				required: true,
				validator: (value: string) => {
					return ['error', 'success'].includes(value);
				}
			},
			/** Text of the CTA button */
			btnText: {
				type: String,
				default: undefined
			},
			/** Router object for ':to' prop of CTA button */
			btnRoute: {
				type: [Array, Object],
				default: () => ({ name: 'home' })
			},
			/** Don't show success/error icon */
			noIcon: {
				type: Boolean,
				default: false
			}
		}
	});

	/** Show error or success message & custom content */
	@Component
	export default class InfoCard extends Props {
		// Icons
		checkIcon = mdiCheckCircle;
		alertIcon = mdiAlert;
	}
